export enum InstanceManagerEvents {
    PlayerCreate = 'playerCreate',
    PlayerDestroy = 'playerDestroy'
}
